/**
 * Shared eligibility status types and utilities for Libra NII assessments
 */

export const ELIGIBILITY_STATUS = {
  ELIGIBLE: 'eligible',
  NOT_ELIGIBLE: 'not_eligible',
  UNCLEAR: 'unclear',
} as const

export type EligibilityStatus =
  (typeof ELIGIBILITY_STATUS)[keyof typeof ELIGIBILITY_STATUS]

export const eligibilityValues = [
  ELIGIBILITY_STATUS.ELIGIBLE,
  ELIGIBILITY_STATUS.NOT_ELIGIBLE,
  ELIGIBILITY_STATUS.UNCLEAR,
] as const

export const ELIGIBILITY_LABELS: Record<EligibilityStatus, string> = {
  [ELIGIBILITY_STATUS.ELIGIBLE]: 'Eligible',
  [ELIGIBILITY_STATUS.NOT_ELIGIBLE]: 'Not Eligible',
  [ELIGIBILITY_STATUS.UNCLEAR]: 'Unclear',
}

export const ELIGIBILITY_COLORS: Record<EligibilityStatus, string> = {
  [ELIGIBILITY_STATUS.ELIGIBLE]: 'green',
  [ELIGIBILITY_STATUS.NOT_ELIGIBLE]: 'red',
  [ELIGIBILITY_STATUS.UNCLEAR]: 'orange',
}

export const ELIGIBILITY_UI_LABELS: Record<EligibilityStatus, string> = {
  [ELIGIBILITY_STATUS.ELIGIBLE]: '✓ NII Eligible',
  [ELIGIBILITY_STATUS.NOT_ELIGIBLE]: '✗ Not Eligible',
  [ELIGIBILITY_STATUS.UNCLEAR]: 'Unclear',
}
